export const MAX_TAGS = 5;
